import ExtendedBadge from "@/components/ExtendedBadge";
import Table from "@/components/Table";
import { statusBadgeVariant, statusLabel } from "@/utils/application-status";
import { Eye } from "lucide-react";
import { Link } from "react-router-dom";


export default function LicencesApplicationsItem({ ...props }: any) {
    return (
        <Table.Row key={props?.id}>
            <Table.Cell>{props?.content?.id}</Table.Cell>
            <Table.Cell>{props?.content?.projectName}</Table.Cell>
            <Table.Cell>{props?.content?.physicalLocation}</Table.Cell>
            <Table.Cell>
                <ExtendedBadge
                    label={statusLabel(props?.content?.applicationStatus) ?? ""}
                    variant={statusBadgeVariant(props?.content?.applicationStatus)} />
            </Table.Cell>
            <Table.Cell>
                <div className="flex items-center space-x-2">
                    <div className="rounded-lg h-8 w-8 flex items-center justify-center border border-[#EDE8E4] cursor-pointer">
                        <Link to={`applications-details/${props?.content?.id}`}>
                            <Eye size={20} />
                        </Link>
                    </div>
                </div>
            </Table.Cell>
        </Table.Row>
    )
}